import { createAsyncThunk } from "@reduxjs/toolkit";
import ProductService from "../../services/ProductService/ProductService";

export const addProduct = createAsyncThunk("addProducts", async (payload) => {
  const res = await ProductService.addProduct(payload);
  return res.data;
});

export const getProducts = createAsyncThunk("getProducts", async (payload) => {
  const res = await ProductService.getAllProducts();
  return res.data;
});

export const updateProduct = createAsyncThunk(
  "update/Product",
  async (payload) => {
    const res = await ProductService.updateProduct(payload);
    return res.data;
  }
);

export const getAssignedProducts = createAsyncThunk(
  "/filter/products",
  async (id) => {
    const res = await ProductService.getAssignedProducts(id);
    return res.data;
  }
);

export const purchasedProducts = createAsyncThunk(
  "/purchased/products",
  async (id) => {
    const res = await ProductService.purchasedProducts(id);
    return res.data;
  }
);
